// Reducer for managing dialog and form state in workflow history
export const initialState = {
	dialogs: {
		deleteConfirm: false,
		cloneConfirm: false,
		editConfirm: false,
		regenerateConfirm: false,
		selectedRecord: null,
		fieldsExtracted: null,
	},
	table: {
		sortField: "status",
		sortDirection: "asc",
		searchInput: "",
		startDateInput: "",
		endDateInput: "",
		searchParams: {
			searchTerm: "",
			startDate: "",
			endDate: "",
		},
	},
	forms: {
		reassignFormData: {
			Driver: null,
			Plate: null,
		},
		templateFormData: {
			Template: null,
		},
		initialFormData: {},
	},
	loading: {
		isLoadingBackdrop: false,
		isBackgroundRefreshing: false,
	},
};

export function workflowHistoryReducer(state, action) {
	switch (action.type) {
		case "CLEAR_FILTERS":
			return {
				...state,
				table: {
					...state.table,
					searchInput: "",
					startDateInput: "",
					endDateInput: "",
					searchParams: {
						searchTerm: "",
						startDate: "",
						endDate: "",
					},
				},
			};
		case "OPEN_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: true,
					selectedRecord: action.payload,
				},
			};
		case "CLOSE_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: false,
					selectedRecord: null,
				},
			};
		case "OPEN_CLONE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					cloneConfirm: true,
					selectedRecord: action.payload,
				},
			};
		case "CLOSE_CLONE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					cloneConfirm: false,
					selectedRecord: null,
				},
			};
		case "OPEN_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: true,
					selectedRecord: action.payload.record,
					fieldsExtracted: action.payload.fields,
				},
			};
		case "CLOSE_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: false,
					selectedRecord: null,
					fieldsExtracted: null,
				},
			};
		case "OPEN_REGENERATE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					regenerateConfirm: true,
					fieldsExtracted: action.payload,
				},
			};
		case "CLOSE_REGENERATE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					regenerateConfirm: false,
					fieldsExtracted: null,
				},
			};
		case "SET_SELECTED_RECORD":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					selectedRecord: action.payload,
				},
			};
		case "SET_FIELDS_EXTRACTED":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					fieldsExtracted: action.payload,
				},
			};
		case "SET_SORT":
			return {
				...state,
				table: {
					...state.table,
					sortField: action.payload.field,
					sortDirection: action.payload.direction,
				},
			};
		case "SET_SEARCH_INPUT":
			return {
				...state,
				table: {
					...state.table,
					searchInput: action.payload,
				},
			};
		case "SET_START_DATE_INPUT":
			return {
				...state,
				table: {
					...state.table,
					startDateInput: action.payload,
				},
			};
		case "SET_END_DATE_INPUT":
			return {
				...state,
				table: {
					...state.table,
					endDateInput: action.payload,
				},
			};
		case "SET_SEARCH_PARAMS":
			return {
				...state,
				table: {
					...state.table,
					searchParams: action.payload,
				},
			};
		case "UPDATE_FORM_DATA":
			return {
				...state,
				forms: {
					...state.forms,
					[action.payload.formName]: action.payload.data,
				},
			};
		case "SET_LOADING":
			return {
				...state,
				loading: {
					...state.loading,
					[action.payload.key]: action.payload.value,
				},
			};
		default:
			return state;
	}
}
